var _radialGradient, _linearGradient, _linearGradient2, _radialGradient2, _linearGradient3, _radialGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _radialGradient4, _radialGradient5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNightTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 215.8434307844,
    cy: 185.72557,
    gradientUnits: "userSpaceOnUse",
    r: 336.6901399656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3952,
    stopColor: "#39375d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6279,
    stopColor: "#323154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8179,
    stopColor: "#262846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9849,
    stopColor: "#151a32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8421,
    stopColor: "#131830"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 482.9624788954,
    x2: 56.6320431576,
    xlinkHref: "#b",
    y1: 311.5015362012,
    y2: 114.0648145024
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 321.3981992772,
    cy: 99.5045321676,
    gradientUnits: "userSpaceOnUse",
    r: 232.3498159162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffebc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2771,
    stopColor: "#ffe9c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5263,
    stopColor: "#fee2bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7641,
    stopColor: "#fdd7a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#fbc78f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbc78e"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 361.6446291196,
    x2: 171.6163498198,
    y1: 399.642775643,
    y2: 209.614395951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0396,
    stopColor: "#e27f04",
    stopOpacity: 0.039216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#c15d2f",
    stopOpacity: 0.466667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    stopColor: "#ad4949",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 120.206608514,
    cy: 209.6661983262,
    gradientUnits: "userSpaceOnUse",
    r: 275.8113059636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3473,
    stopColor: "#e9f5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dff0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8666,
    stopColor: "#cee7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#c2e0ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#bfdcfd",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eb2e7"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 295.8143514214,
    x2: 335.570465759,
    xlinkHref: "#g",
    y1: 393.803965291,
    y2: 273.8615890474
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 250.3332714866,
    x2: 301.4475585478,
    xlinkHref: "#g",
    y1: 311.749404543,
    y2: 235.9644370772
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 68.1180151518,
    x2: -12.5703081464,
    xlinkHref: "#g",
    y1: 392.6550769542,
    y2: 316.398065364
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 181.750540841,
    x2: 181.750540841,
    xlinkHref: "#g",
    y1: 409.9614875278,
    y2: 503.156169141
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 174.3994223882,
    x2: 76.8556502788,
    xlinkHref: "#g",
    y1: 501.0312678358,
    y2: 403.4874957264
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 486.5469823964,
    x2: 404.6139966026,
    xlinkHref: "#b",
    y1: 192.5062599724,
    y2: 110.5731737864
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 395.4620428662,
    cy: 55.6807266704,
    gradientUnits: "userSpaceOnUse",
    r: 112.5228907026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 260.2229071086,
    cy: 109.3974807322,
    gradientUnits: "userSpaceOnUse",
    r: 507.890163332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#ffdc77",
    stopOpacity: 0.862745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4331,
    stopColor: "#ffebb1",
    stopOpacity: 0.568627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    stopColor: "#fff6db",
    stopOpacity: 0.313725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    stopColor: "#fffcf5",
    stopOpacity: 0.117647
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m269.503906 11.804688c-71.230468 35.625-115.996094 116.398437-96.296875 204.855468 7.011719 31.476563 26.957031 63.171875 53 88.261719l167.140625 167.144531c71.332032-45.441406 118.652344-125.222656 118.652344-216.066406 0-1.066406-.027344-2.128906-.039062-3.195312l-239.488282-239.488282c.546875-1.253906-.996094-2.496094-2.96875-1.511718zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m438.945312 268.003906c-99.761718-.246094-181.320312-81.804687-181.566406-181.566406-.066406-26 5.332032-50.730469 15.09375-73.117188.546875-1.257812-.996094-2.5-2.96875-1.511718-71.230468 35.621094-115.996094 116.394531-96.296875 204.851562 13.496094 60.59375 74.921875 122.019532 135.515625 135.515625 86.839844 19.339844 166.382813-23.40625 202.863282-92.425781 1.507812-2.847656-1.382813-6.011719-4.375-4.808594-21.089844 8.472656-44.128907 13.121094-68.265626 13.0625zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m249.234375 266.046875c-9.609375 0-18.546875 2.875-26.007813 7.800781-.199218-.195312-11.144531-11.148437-11.910156-11.890625-8.449218-8.78125-18.660156-15.847656-30.058594-20.652343 22.144532 51.769531 75.113282 99.210937 127.464844 110.871093 17.261719 3.84375 34.234375 5.226563 50.636719 4.449219l-75.550781-75.554688c-8.640625-9.238281-20.929688-15.023437-34.574219-15.023437zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m296.566406 324.601562c-.453125 0-.90625.007813-1.355468.015626.878906-3.601563 1.355468-7.363282 1.355468-11.238282 0-26.140625-21.191406-47.332031-47.332031-47.332031-10.28125 0-19.792969 3.292969-27.554687 8.859375-16.164063-24.492188-43.921876-40.660156-75.464844-40.660156-49.902344 0-90.355469 40.453125-90.355469 90.355468 0 .304688.007813.609376.011719.914063-31.703125 5.277344-55.871094 32.824219-55.871094 66.023437 0 36.964844 29.96875 66.933594 66.9375 66.933594h229.628906c36.96875 0 66.933594-29.96875 66.933594-66.933594 0-36.96875-29.96875-66.9375-66.933594-66.9375zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m363.5 391.539062c0 36.96875-29.96875 66.933594-66.933594 66.933594-36.96875 0-66.9375-29.964844-66.9375-66.933594s29.96875-66.9375 66.9375-66.9375c36.964844 0 66.933594 29.96875 66.933594 66.9375zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m296.566406 313.378906c0 26.140625-21.191406 47.332032-47.332031 47.332032s-47.332031-21.191407-47.332031-47.332032 21.191406-47.332031 47.332031-47.332031 47.332031 21.191406 47.332031 47.332031zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m133.871094 391.539062c0 36.96875-29.964844 66.9375-66.933594 66.9375s-66.9375-29.96875-66.9375-66.9375 29.96875-66.9375 66.9375-66.9375 66.933594 29.96875 66.933594 66.9375zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m.621094 400.65625c4.445312 32.652344 32.4375 57.816406 66.316406 57.816406h229.628906c33.875 0 61.867188-25.164062 66.316406-57.816406zm0 0",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m190.328125 458.472656-3.492187-3.492187c-4.957032-5.355469-12.042969-8.710938-19.917969-8.710938-.09375 0-.183594.007813-.277344.007813-.054687-.050782-.105469-.101563-.160156-.15625l-17.914063-17.914063c-7.792968-8.160156-18.769531-13.25-30.945312-13.25-23.632813 0-42.792969 19.160157-42.792969 42.796875 0 .117188.007813.230469.007813.347656-.511719.105469-1.011719.230469-1.507813.371094zm0 0",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 9.539062-.542969 18.953125-1.554688 28.230469l-147.027343-147.023438-.117188-.03125c-5.535156-4.96875-9.007812-12.175781-9.007812-20.1875 0-15 12.167969-27.167969 27.167969-27.167969 2.699218 0 5.308593.402344 7.769531 1.136719 3.792969-15.300781 15.84375-27.359375 31.144531-31.195312 25.957031 21.757812 47.542969 48.582031 63.214844 78.941406 18.160156 35.136719 28.410156 75.023437 28.410156 117.296875zm0 0",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m473.609375 101.667969c.003906-.117188.011719-.234375.011719-.351563 0-23.652344-19.175782-42.828125-42.832032-42.828125-20.078124 0-36.925781 13.820313-41.558593 32.46875-2.460938-.734375-5.070313-1.132812-7.769531-1.132812-15 0-27.164063 12.160156-27.164063 27.160156s12.160156 27.160156 27.164063 27.160156h87.847656c11.851562 0 21.457031-9.605469 21.457031-21.453125 0-10.375-7.367187-19.03125-17.15625-21.023437zm0 0",
    fill: "url(#n)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m296.566406 324.601562c-.453125 0-.90625.007813-1.355468.015626.878906-3.601563 1.355468-7.363282 1.355468-11.238282 0-26.140625-21.191406-47.332031-47.332031-47.332031-10.28125 0-19.792969 3.292969-27.554687 8.859375-16.164063-24.492188-43.921876-40.660156-75.464844-40.660156-49.902344 0-90.355469 40.453125-90.355469 90.355468 0 .304688.007813.609376.011719.914063-31.703125 5.277344-55.871094 32.824219-55.871094 66.023437 0 36.964844 29.96875 66.933594 66.9375 66.933594h229.628906c36.96875 0 66.933594-29.96875 66.933594-66.933594 0-36.96875-29.96875-66.9375-66.933594-66.9375zm0 0",
    fill: "url(#o)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNightTime);
export default __webpack_public_path__ + "static/media/icon-night-time.d0cf6b3e99aee83ae4f225330f032d5a.svg";
export { ForwardRef as ReactComponent };